import React from "react"

const Footer = () => {
  const currentYear: number = new Date().getFullYear()

  return (
    <footer className="z-0 font-normal md:pl-80 md:pr-16 text-[0.625rem]">
      <div className="pt-12 flex flex-wrap items-center md:justify-between justify-center">
        <div className="w-full text-center">
          <div className="mb-4" data-testid="ba-footercopyright">
            &copy; {currentYear} Wolf &amp; Badger |{` `}
            <a
              href="/pages/terms/"
              className="hover:underline underline-offset-1"
              target="_blank"
              rel="noreferrer noopener"
            >
              Terms & Conditions
            </a>
            {` `}|{` `}
            <a
              href="/pages/privacy/"
              className="hover:underline underline-offset-1"
              target="_blank"
              rel="noreferrer noopener"
            >
              Privacy Policy
            </a>
            {` `}|{` `} Visit:{` `}
            <a
              href="/"
              target="_blank"
              className="hover:underline underline-offset-1"
              rel="noreferrer noopener"
            >
              wolfandbadger.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
